/** Sesso */
export enum GenderTypes {
  /** Maschile */
  M = 'M',
  /** Femminile */
  F = 'F'
}
